import React, { Profiler, useEffect, useRef, useState } from "react";
import api from "~/services/api";
import { LandPage, Main, ThisProgress, Carregando } from './styles';
import { Colors } from "~/config/Colors";
import { Materialize } from "~/styles/materializeGrid";

import IconInsatisfeito from '~/assets/icones/icon_insatisfeito.png';
import IconMuitoInsatisfeito from '~/assets/icones/icon_muito_insatisfeito.png';
import IconSatisfeito from '~/assets/icones/icon_satisfeito.png';
import IconMuitosatisfeito from '~/assets/icones/icon_muito_satisfeito.png';
import IconNormal from '~/assets/icones/icon_muito_normal.png';
import IconArrowUp from '~/assets/icones/IconArrowUp.svg';
import IconArrowDown from '~/assets/icones/IconArrowDown.svg';

import GaugeChart from 'react-gauge-chart';
import { renderToString } from "react-dom/server";

import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';

import NunitoSemiBold from '~/utils/Nunito-semiBold.js';
import PainelPDF from "./Template/PainelPDF";
import { Table } from "./components/Table";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";

export default function Painel() {
  let { hash } = useParams();
  const [countRefComment, setCountRefComment] = useState(0);
  const [propriedadeGeral, setPropriedadeGeral] = useState({});
  const [countFilterAvaliation, setCountFilterAvaliation] = useState({
    abertoTotal: true,
    abertoMuitoSatisfeito: true,
    abertoSatisfeito: true,
    abertoNormal: true,
    abertoInsatisfeito: true,
    abertoMuitoInsatisfeito: true,
  });
    
  const [carregandoPDF, setCarregandoPDF] = useState(false);
  const [imprimePDF, setImprimePDF] = useState(false);
  const [commentOpen, setCommentOpen] = useState(true);
  
  let countAvaliation = {
    abertoTotal: true,
    total: 0, 
    listaMuitoSatisfeito: [],
    muitoSatisfeito: 0, 
    abertoMuitoSatisfeito: true,
    listaSatisfeito: [],
    satisfeito: 0, 
    abertoSatisfeito: true,
    listaNormal: [],
    normal: 0, 
    abertoNormal: true,
    listaInsatisfeito: [],
    insatisfeito: 0,
    abertoInsatisfeito: true,
    listaMuitoInsatisfeito: [],
    muitoInsatisfeito: 0,
    abertoMuitoInsatisfeito: true,
  };
  let dataAnterior = [];
  
  const cores = [
    "#2E7AD3",
    "#FF5780",
    "#802ED3",
    "#C62ED3",
    "#CAC4C8",
    "#CE6D14",
    "#D32EA5",
    "#14ADCE",
    "#4691C7",
    "#FF9090",
    "#D4F37B",
    "#FFF27E",
    "#4F4F4F",
    "#B9FFDE",
    "#B9D1FF",
  ];

  const cabecalhoRef = useRef(null);
  const chartRefs = useRef([]);
  const filterRef = useRef(null);
  const commentsRefs = useRef([]);

  useEffect(() => {
    api.get("/unsigned/relatorioenviado", { params: { osHash: hash } })
      .then(response => {
        setPropriedadeGeral(response.data)
        // setChartPrincipal(response.data.pesquisa)
        // setData(response.data.comentarios)
        // setDataFilter(response.data.filter)
      });
  }, []);

  const data = propriedadeGeral?.comentarios || [];
  const chartPrincipal = propriedadeGeral?.pesquisa || [];
  const dataFilter = propriedadeGeral?.filter || {};

  if (data?.length > 0) {
    let lista = [];
    
    for (const element of data) {
      let find = dataAnterior?.find((e) => e?.id == element?.id);
      if (!find) {
        lista.push({ ...element, aberto: true });
      }
    }

    dataAnterior = [...dataAnterior, ...lista];

    let itemAvaliation = {
      abertoTotal: true,
      total: 0, 
      listaMuitoSatisfeito: [],
      muitoSatisfeito: 0, 
      abertoMuitoSatisfeito: true,
      listaSatisfeito: [],
      satisfeito: 0, 
      abertoSatisfeito: true,
      listaNormal: [],
      normal: 0, 
      abertoNormal: true,
      listaInsatisfeito: [],
      insatisfeito: 0,
      abertoInsatisfeito: true,
      listaMuitoInsatisfeito: [],
      muitoInsatisfeito: 0,
      abertoMuitoInsatisfeito: true,
    };
    
    for (const dataAvaliation of dataAnterior) {
      if (dataAvaliation?.percentualSatisfacao > 80) {
        itemAvaliation.muitoSatisfeito += 1;
        itemAvaliation.listaMuitoSatisfeito.push(dataAvaliation);
      }

      if (dataAvaliation?.percentualSatisfacao > 60 && dataAvaliation?.percentualSatisfacao <= 80) {
        itemAvaliation.satisfeito += 1;
        itemAvaliation.listaSatisfeito.push(dataAvaliation);
      }

      if (dataAvaliation?.percentualSatisfacao > 40 && dataAvaliation?.percentualSatisfacao <= 60) {
        itemAvaliation.normal += 1;
        itemAvaliation.listaNormal.push(dataAvaliation);
      }

      if (dataAvaliation?.percentualSatisfacao > 20 && dataAvaliation?.percentualSatisfacao <= 40) {
        itemAvaliation.insatisfeito += 1;
        itemAvaliation.listaInsatisfeito.push(dataAvaliation);
      }

      if (dataAvaliation?.percentualSatisfacao <= 20) {
        itemAvaliation.muitoInsatisfeito += 1;
        itemAvaliation.listaMuitoInsatisfeito.push(dataAvaliation);
      }

      itemAvaliation.total += 1;
    }

    countAvaliation = itemAvaliation;
  }

  const handleDownloadPainel = async () => {   
    let htmlElement = <div />;
    
    let elementAsString = renderToString(htmlElement);

    const doc = new jsPDF({
      format: "a4",
      unit: "px",
      orientation: 'landscape'
    });
    
    let row = 100;
    let indice = 0;

    doc.addFileToVFS('Nunito-semibold.ttf', NunitoSemiBold);
    doc.addFont('Nunito-semibold.ttf', 'Nunito', 'normal');
    doc.setFont('Nunito');
    // doc.setFontSize(10);

    if (cabecalhoRef) {
      const imgData = await html2canvas(cabecalhoRef.current, { scale: 3, }).then(canvas => {
        return canvas.toDataURL('image/png');
      });
      doc.addImage(imgData, 'PNG', 8, 0, 617, 85);
    }

    for (const element of chartRefs.current) {
      if (element) {
        const imgData = await html2canvas(element, { scale: 3, }).then(canvas => {
          return canvas.toDataURL('image/png');
        });

        if (chartPrincipal[indice]?.tipo == "SF") {
          if (chartPrincipal[indice]?.aberto) {
            if ((row + 130) > 460) {
              row = 10;
              doc.addPage();
            }

            doc.addImage(imgData, 'PNG', 10, row, 613, 120);
            row += 130;
          } else {
            if ((row + 57) > 460) {
              row = 10;
              doc.addPage();
            }

            doc.addImage(imgData, 'PNG', 10, row, 613, 47);
            row += 57;
          }
        } else if (chartPrincipal[indice]?.tipo == "MP") {
          if (chartPrincipal[indice]?.aberto) {
            if ((row + 140) > 460) {
              row = 10;
              doc.addPage();
            }

            doc.addImage(imgData, 'PNG', 10, row, 613, 130);
            row += 140;
          } else {
            if ((row + 57) > 460) {
              row = 10;
              doc.addPage();
            }

            doc.addImage(imgData, 'PNG', 10, row, 613, 47);
            row += 57;
          }
        } else if (chartPrincipal[indice]?.tipo == "CF") {
          if (chartPrincipal[indice]?.aberto) {
            if ((row + 67) > 460) {
              row = 10;
              doc.addPage();
            }

            doc.addImage(imgData, 'PNG', 10, row, 613, 57);
            row += 67;
          } else {
            if ((row + 57) > 460) {
              row = 10;
              doc.addPage();
            }

            doc.addImage(imgData, 'PNG', 10, row, 613, 47);
            row += 57;
          }
        }

        indice++;
      }
    }

    if (filterRef) {
      const imgData = await html2canvas(filterRef.current, { scale: 3, }).then(canvas => {
        return canvas.toDataURL('image/png');
      });

      if ((row + 57) > 460) {
        row = 10;
        doc.addPage();
      }

      doc.addImage(imgData, 'PNG', 10, row, 613, 47);
      row += 57;
    }
    
    indice = 0;
    for (const element of commentsRefs.current) {
      if (element) {
        const imgData = await html2canvas(element, { scale: 3, }).then(canvas => {
          return canvas.toDataURL('image/png');
        });

        if (dataAnterior[indice]?.aberto) {
          let heightText = 30 + 10;

          if ((row + heightText) > 460) {
            row = 10;
            doc.addPage();
          }

          for (const itemComm of dataAnterior[indice]?.comentarios) {
            heightText += (itemComm?.texto.length >= 140 ? 60 : 50);

            if ((row + heightText) > 460) {
              row = 10;
              doc.addPage();
            }
          }

          doc.addImage(imgData, 'PNG', 10, row, 613, heightText - 10);
          row += heightText;
        } else {
          if ((row + 47) > 460) {
            row = 10;
            doc.addPage();
          }

          doc.addImage(imgData, 'PNG', 10, row, 613, 37);
          row += 47;
        }

        indice++;
      }
    }

    doc.html(elementAsString);
    doc.save(dataFilter?.tituloPesquisa + ".pdf");
    setCarregandoPDF(false);
    // window.close();
  };

  useEffect(() => {
    if (imprimePDF) {
      setImprimePDF(false);
      setCarregandoPDF(true);
    }
  }, [imprimePDF]);
  
  useEffect(() => {
    if (carregandoPDF === true) {
      setTimeout(() => {
        handleDownloadPainel();
      }, 2000);
    }
  }, [carregandoPDF]);

  useEffect(() => {
    if (propriedadeGeral?.pesquisa?.length > 0 && data?.length == countRefComment) {
      setCarregandoPDF(true);
    }
  }, [propriedadeGeral, countRefComment]);

  // window.onload = function () { alert("Está carregado!") } 
  return (
    <Main>
      <LandPage>
        <div className="content">
          <Materialize className="materialize">
            <div className="row header">
              <div className="divTitle">
                <div className="div-icone">
                  <h4 className="title">Painel</h4>
                  <h5 className="sub-title">Visualize as informações e tenha uma análise prévia das pesquisas</h5>
                </div>
              </div>
              <div className="div-bt">
                <button
                  className="btn-filtro"
                  onClick={() => setImprimePDF(true)}
                >
                  PDF
                </button>
              </div>
            </div>
            <div ref={cabecalhoRef}>
              <PainelPDF data={dataFilter} />
            </div>
          </Materialize>
          <div className="back-section">
            <div className="ref">
              {chartPrincipal?.map((itemPergunta, indicePergunta) => (
                <div 
                  ref={ref => {
                    if (ref) {
                      const find = chartRefs.current.find((item) => item == ref);
                      !find && chartRefs.current.push(ref);
                    }
                  }}
                  data-tkey={itemPergunta?.id}
                  className="section-1" 
                  key={itemPergunta?.id}
                >
                  <div className="sc-top">
                    <div className="div-title">
                      <div className="title">
                        {indicePergunta + 1}. {itemPergunta?.titulo}
                      </div>
                      <div className="total-satis">
                        <div className="resumo">
                          <p className="ct-title">Satisfação</p>
                          <p className="ct-quant">{itemPergunta?.quantidade + " respostas"}</p>
                        </div>
                        {!itemPergunta.aberto && (<img className="icon-arrow" src={IconArrowDown} alt="" />)}
                        {itemPergunta.aberto && (<img className="icon-arrow" src={IconArrowUp} alt="" />)}
                      </div>
                    </div>
                    {!itemPergunta.aberto && (
                      <div className="div-sumary">
                        <div className="list">
                          {itemPergunta?.listaItens?.map((itemItem, a) => (
                            <div className="item-pergunta">
                              {itemPergunta?.tipo == "SF" && (
                                itemItem?.estrela == "1"
                                  ? (
                                    <div className="col-1-1 align-left">
                                      <img src={IconMuitosatisfeito} alt="Vazio" />
                                    </div>
                                  ) : itemItem?.estrela == "2" ? (
                                    <div className="col-1-1 align-left">
                                      <img src={IconSatisfeito} alt="Vazio" />
                                    </div>
                                  ) : itemItem?.estrela == "3" ? (
                                    <div className="col-1-1 align-left">
                                      <img src={IconNormal} alt="Vazio" />
                                    </div>
                                  ) : itemItem?.estrela == "4" ? (
                                    <div className="col-1-1 align-left">
                                      <img src={IconInsatisfeito} alt="Vazio" />
                                    </div>
                                  ) : (
                                    <div className="col-1-1 align-left">
                                      <img src={IconMuitoInsatisfeito} alt="Vazio" />
                                    </div>
                                  )
                              )}
                              {itemPergunta?.tipo != "SF" && (
                                <div className="col-2">
                                  <p className="titulo-item">{itemItem?.titulo}</p>
                                </div>
                              )}
                              <div className="col-1-1 align-right">
                                <p className="titulo-item">{(itemItem?.porcentagem || 0)?.toFixed(1)}%</p>
                              </div>
                            </div>
                          ))}
                        </div>
                        {itemPergunta?.tipo == "SF" && (
                          <div className="chart-total">
                            <div className="chart-tt-circle">
                              <GaugeChart id="gauge-chart5"
                                arcsLength={[0.2, 0.2, 0.2, 0.2, 0.2]}
                                colors={['#FF5780', '#FFAB48', '#FFD147', '#B6DF53', '#2ed3b5']}
                                textColor={Colors.Color3}
                                hideText={true}
                                percent={itemPergunta?.percentualSatisfacao/100}
                                arcPadding={0.02}
                                needleColor={localStorage.getItem("tema") == "E" ? Colors.Color3 : Colors.Color3}
                                needleBaseColor={localStorage.getItem("tema") == "E" ? Colors.Color3 : Colors.Color3}
                                style={{ width: '90%' }}
                              />
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                  {itemPergunta.aberto && (
                    <div className="chart-barra">
                      <div className="list">
                        {itemPergunta?.listaItens?.map((itemItem, a) => (
                          <div className="item-pergunta">
                            {
                              itemPergunta?.tipo == "SF" && (
                                itemItem?.estrela == "1"
                                  ? (
                                    <div className="col-1-1 align-left">
                                      <img src={IconMuitosatisfeito} alt="Vazio" />
                                    </div>
                                  ) : itemItem?.estrela == "2" ? (
                                    <div className="col-1-1 align-left">
                                      <img src={IconSatisfeito} alt="Vazio" />
                                    </div>
                                  ) : itemItem?.estrela == "3" ? (
                                    <div className="col-1-1 align-left">
                                      <img src={IconNormal} alt="Vazio" />
                                    </div>
                                  ) : itemItem?.estrela == "4" ? (
                                    <div className="col-1-1 align-left">
                                      <img src={IconInsatisfeito} alt="Vazio" />
                                    </div>
                                  ) : (
                                    <div className="col-1-1 align-left">
                                      <img src={IconMuitoInsatisfeito} alt="Vazio" />
                                    </div>
                                  )
                              )
                            }
                            <div className="col-3">
                              <p className="titulo-item">{itemItem?.titulo}</p>
                            </div>
                            <div className="col-3">
                              <div className="progress">
                                {
                                  itemPergunta?.tipo == "SF" ? (
                                    itemItem?.estrela == "1"
                                      ? (
                                        <ThisProgress backgound={'#2ED3B5'} width={itemItem?.porcentagem + "%"} />
                                      ) : itemItem?.estrela == "2" ? (
                                        <ThisProgress backgound={'#B6DF53'} width={itemItem?.porcentagem + "%"} />
                                      ) : itemItem?.estrela == "3" ? (
                                        <ThisProgress backgound={'#FFD147'} width={itemItem?.porcentagem + "%"} />
                                      ) : itemItem?.estrela == "4" ? (
                                        <ThisProgress backgound={'#FFAB48'} width={itemItem?.porcentagem + "%"} />
                                      ) : (
                                        <ThisProgress backgound={'#FF5780'} width={itemItem?.porcentagem + "%"} />
                                      )
                                  ) : (
                                    <ThisProgress backgound={cores[a]} width={itemItem?.porcentagem + "%"} />
                                  )
                                }
                              </div>
                            </div>
                            <div className="col-1 align-right">
                              <p className="titulo-item">{itemItem?.quantidade}</p>
                            </div>
                            <div className="col-1-1 align-center">
                              <p className="titulo-item">|</p>
                            </div>
                            <div className="col-1-1 align-right">
                              <p className="titulo-item">{itemItem?.porcentagem?.toFixed(1)}%</p>
                            </div>
                          </div>
                        ))}
                      </div>
                      {itemPergunta?.tipo == "SF" && (
                        <div className="chart-total">
                          <div className="chart-tt-circle">
                            <GaugeChart id="gauge-chart5"
                              arcsLength={[0.2, 0.2, 0.2, 0.2, 0.2]}
                              colors={['#FF5780', '#FFAB48', '#FFD147', '#B6DF53', '#2ed3b5']}
                              textColor={Colors.Color3}
                              percent={itemPergunta?.percentualSatisfacao/100}
                              arcPadding={0.02}
                              needleColor={localStorage.getItem("tema") == "E" ? Colors.Color3 : Colors.Color3}
                              needleBaseColor={localStorage.getItem("tema") == "E" ? Colors.Color3 : Colors.Color3}
                              style={{ width: '90%' }}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              ))}
            </div>
            <div className="section-2">
              <div className="ref2">
                <div className="sc-top" ref={filterRef}>
                  <div className="div-title" onClick={() => setCommentOpen(!commentOpen)}>
                    <div className="title">
                      {chartPrincipal?.length + 1}. Lista de Comentários
                    </div>
                    {!commentOpen && (<img className="icon-arrow" src={IconArrowDown} alt="" />)}
                    {commentOpen && (<img className="icon-arrow" src={IconArrowUp} alt="" />)}
                  </div>
                  <div className="div-sumary">
                    <div className="list">
                      <div className="item-pergunta">
                        <div className="col-1-1 align-left">
                          <p className="titulo-item">Total</p>
                        </div>
                        <div className="col-1-2 align-center">
                          <p className="titulo-item">{(countAvaliation.total)}</p>
                        </div>
                      </div>
                    </div>
                    <div className="list">
                      <div 
                        className={countFilterAvaliation?.abertoMuitoSatisfeito ? "item-pergunta click" : "item-pergunta click desativado"} 
                        onClick={() => {
                          setCountFilterAvaliation((state) => {
                            return { 
                              ...state,
                              abertoMuitoSatisfeito: !state.abertoMuitoSatisfeito
                            };
                          })
                        }}
                      >
                        <div className="col-1-1 align-left">
                          <img src={IconMuitosatisfeito} alt="Vazio" />
                        </div>
                        <div className="col-1-2 align-center">
                          <p className="titulo-item">{(countAvaliation.muitoSatisfeito)}</p>
                        </div>
                      </div>
                      <div 
                        className={countFilterAvaliation?.abertoSatisfeito ? "item-pergunta click" : "item-pergunta click desativado"} 
                        onClick={() => {
                          setCountFilterAvaliation((state) => {
                            return { 
                              ...state,
                              abertoSatisfeito: !state.abertoSatisfeito
                            };
                          })
                        }}
                      >
                        <div className="col-1-1 align-left">
                          <img src={IconSatisfeito} alt="Vazio" />
                        </div>
                        <div className="col-1-2 align-center">
                          <p className="titulo-item">{(countAvaliation.satisfeito)}</p>
                        </div>
                      </div>
                      <div 
                        className={countFilterAvaliation?.abertoNormal ? "item-pergunta click" : "item-pergunta click desativado"} 
                        onClick={() => {
                          setCountFilterAvaliation((state) => {
                            return { 
                              ...state,
                              abertoNormal: !state.abertoNormal
                            };
                          })
                        }}
                      >
                        <div className="col-1-1 align-left">
                          <img src={IconNormal} alt="Vazio" />
                        </div>
                        <div className="col-1-2 align-center">
                          <p className="titulo-item">{(countAvaliation.normal)}</p>
                        </div>
                      </div>
                      <div 
                        className={countFilterAvaliation?.abertoInsatisfeito ? "item-pergunta click" : "item-pergunta click desativado"} 
                        onClick={() => {
                          setCountFilterAvaliation((state) => {
                            return { 
                              ...state,
                              abertoInsatisfeito: !state.abertoInsatisfeito
                            };
                          })
                        }}
                      >
                        <div className="col-1-1 align-left">
                          <img src={IconInsatisfeito} alt="Vazio" />
                        </div>
                        <div className="col-1-2 align-center">
                          <p className="titulo-item">{(countAvaliation.insatisfeito)}</p>
                        </div>
                      </div>
                      <div 
                        className={countFilterAvaliation?.abertoMuitoInsatisfeito ? "item-pergunta click" : "item-pergunta click desativado"} 
                        onClick={() => {
                          setCountFilterAvaliation((state) => {
                            return { 
                              ...state,
                              abertoMuitoInsatisfeito: !state.abertoMuitoInsatisfeito
                            };
                          })
                        }}
                      >
                        <div className="col-1-1 align-left">
                          <img src={IconMuitoInsatisfeito} alt="Vazio" />
                        </div>
                        <div className="col-1-2 align-center">
                          <p className="titulo-item">{(countAvaliation.muitoInsatisfeito)}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {commentOpen && countAvaliation && countFilterAvaliation && dataAnterior.length > 0 && (
                  <div className="lista-comentarios">
                    <Table 
                      comments={dataAnterior}
                      optionsFilter={countAvaliation}
                      countFilterAvaliation={countFilterAvaliation}
                      commentsRefs={commentsRefs}
                      setCountRefComment={setCountRefComment}
                      countRefComment={countRefComment}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        {(chartPrincipal.length == 0 || data.length != countRefComment) && (
          <Carregando>
            <p>Aguarde enquanto preparamos os dados...</p>
          </Carregando>
        )}
        {(carregandoPDF) && (
          <Carregando>
            <p>Aguarde enquanto geramos o pdf...</p>
          </Carregando>
        )}
      </LandPage>
    </Main>
  );
}
